
import { VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const PriceFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "checkbox",
                        "name": "default",
                        "label": "Precio Por Defecto",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "number",
                        "label": "Numero Precio",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 2
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "title",
                        "label": "Descripcion Precio",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "formula",
                        "label": "Formula Calculo",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ]
            ]
        }
    ],
};


export default PriceFormConfig;